var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-part" }, [
    _c("img", {
      staticClass: "logo-icon-cls",
      attrs: { src: require("@/assets/img/icon-kpmglogo.svg"), width: "100%" },
    }),
    _vm.$i18n.locale === "en"
      ? _c(
          "span",
          {
            staticStyle: { cursor: "pointer" },
            on: { click: _vm.toogleLanguage },
          },
          [_vm._v("切换中文"), _c("i", { staticClass: "el-icon-caret-right" })]
        )
      : _vm.$i18n.locale === "zh"
      ? _c(
          "span",
          {
            staticStyle: { cursor: "pointer" },
            on: { click: _vm.toogleLanguage },
          },
          [_vm._v("English"), _c("i", { staticClass: "el-icon-caret-right" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }